// Generated by https://quicktype.io

export interface ClassesEligible {
  _id:   string;
  name:  string;
  value: number;
}

export enum CourseStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  EXPIRED = 'EXPIRED',
  LIVE = 'LIVE',
  PAST='PAST',
}

export interface Course {
  id:          string;
  name:        string;
  targetYear:  string;
  classId:     string;
  className:   string;
  isExpired:   boolean;
  endDate:     string;
  startDate:   string;
  status:      CourseStatus;
  groupStatus: number;
  groupId: string;
}


export interface GoalListItem {
  _id:             string;
  classesEligible: ClassesEligible[];
  courses:         Course[];
  name:            string;
  updatedAt:       string;
  color:           string;
  image:           null;
  clientID:        string;
  status:          string;
  versionYears: Course[];
}
